import { render, staticRenderFns } from "./locations.vue?vue&type=template&id=2145a0e9&scoped=true"
import script from "./locations.vue?vue&type=script&lang=ts"
export * from "./locations.vue?vue&type=script&lang=ts"
import style0 from "./locations.vue?vue&type=style&index=0&id=2145a0e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145a0e9",
  null
  
)

export default component.exports